import React, { useState, useEffect } from 'react';
import { Helmet } from "react-helmet";
import PropTypes from 'prop-types';
import { HeaderStepper } from '../Common/HeaderStepper/HeaderStepper';
import DisabilityData from '../../Helpers/Data/Products/Disability/DisabilityData';
import * as Steps from './steps';
import { saveSessionEvent } from "../../../session";
import { getSessionStorageItem, setSessionStorageItem, SESSION_STORAGE_DISABILITY_KEY, getBasicInfo } from '../../../sessionStorage';

export default function Disability(props) {

  useEffect(() => { saveSessionEvent() }, [props.location])

  var sessionStorageFormState = getSessionStorageItem(SESSION_STORAGE_DISABILITY_KEY);

  if (props.landing && sessionStorageFormState) {
    sessionStorageFormState.currentStep = 0;
  }

  const path = props.location ? props.location.pathname.split("/").pop() : null;
  const prefill = props.location && props.location.search && props.location.search.toLowerCase().includes('prefill');
  const shiftOrder = props.landing || (props.location && props.location.search && props.location.search.toLowerCase().includes('shift'));
  const basicInfo = getBasicInfo();

  const newFormState = {
    currentStep: 0,
    pages: {
      basicInfo: Steps.BasicInfo.DefaultFormState(prefill, basicInfo),
    },
  };

  const initialFormState = sessionStorageFormState || newFormState;

  const [formState, setFormState] = useState(initialFormState);

  // update the formState when the url path changes the step
  useEffect(() => {
    if (!path || path === steps[formState.currentStep].path) {
      return;
    }

    const nextStep = steps.findIndex(s => s.path === path);

    if (nextStep < 0) {
      return;
    }

    const newFormState = { ...formState, currentStep: nextStep };
    setFormState(newFormState);
  }, [path]);

  const onNext = () => {
    var redirect = "";
    if (formState.pages.basicInfo.insuranceType === 2) {
      redirect = "ameritas-dinamic-Fundamental/get-a-quote";
    } else if (formState.pages.basicInfo.insuranceType === 0) {
      redirect = "long-term/employment-details";
    }
     else if (formState.currentStep >= steps.length - 1) {
      console.error('onNext did not find a next step');
      return;
    }

    var newFormState = { ...formState };
    setFormState(newFormState);
    setSessionStorageItem(SESSION_STORAGE_DISABILITY_KEY, newFormState);

    props.history.push(`/quote/disability/${redirect}`);
    window.scroll(0, 0);
  };

  const onBack = () => {
    if (formState.currentStep <= 0) {
      window.location.replace(`landing/disability-income`);
      return;
    }

    const backStep = steps[formState.currentStep - 1];
    const newFormState = { ...formState, currentStep: formState.currentStep - 1 };

    setFormState(newFormState);
    setSessionStorageItem(SESSION_STORAGE_DISABILITY_KEY, newFormState);

    props.history.push(`/quote/term-life-insurance/${backStep.path}`);
    window.scroll(0, 0);
  };

  const onFieldChange = (step, field, value) => {
    setFormState({ ...formState, pages: { ...formState.pages, [step]: { ...formState.pages[step], [field]: value } } });
  };

  const steps = [
    {
      path: 'basic-info',
      progressTitle: 'Basic Information',
      component: (
        <Steps.BasicInfo
          formState={formState.pages.basicInfo}
          onFieldChange={(field, value) => onFieldChange('basicInfo', field, value)}
          onNext={onNext}
          onBack={onBack}
          hideBack={props.landing}
          ageSpecs={DisabilityData().specs.age}
        />
      ),
    },
  ];

  if (shiftOrder) {
    var step = steps.pop();
    steps.unshift(step);
  }

  const currentStepObj = steps.find((s, index) => index === formState.currentStep) || steps[0];

  return (
    <div>
      <Helmet>
        <title>Disability - {currentStepObj.progressTitle} </title>
      </Helmet>
      <HeaderStepper
        hidden={props.landing}
        hideProgressTracker={currentStepObj.hideProgressTracker}
        stepName={currentStepObj.progressTitle}
        step={formState.currentStep + 1}
        totalSteps={steps.length}
      >
        {currentStepObj.component}
      </HeaderStepper>
    </div>
  );
}

Disability.propTypes = {
  landing: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/components/Quoters/Disability/Disability.js